import React, { useEffect, useRef, useState } from "react"
import { beginnerBannerText, ColourPalette, getAdjustingFontSizeByHeightWidth, getIsMobile, getIsTablet, getScreenSize, getSectionHeight, isSafari, pageType } from "../globalConstants"
import { VerticalPhoneMobile, VerticalPhoneWithVideo } from "./verticalPhoneWithVideo"
import postFlopAll from "../assets/gamePlayVideo.mp4";
import gameScreenPhoto from "../assets/question_1.png"
import resultsScreen from "../assets/resultsScreen.mp4";
import resultsScreenPhoto from "../assets/answer_1.png"
import { DownloadButtonsDesktop } from "./DownloadButtonsDesktop";
import { DownloadButtonsMobile } from "./DownloadButtonsMobile";
import HandHistoryGreyScale from "../assets/Tile_HandHistory.png"
import { FlexiblePhone, FlexiblePhoneStillImage } from "./flexiblePhone";
import { formatAnswer } from "./DuplicatePoker";
import FeedbackIcon from "../assets/feedbackIcon.png";
import AppLogoOrange from "../assets/appLogoAccentOrange.png";
import ResultsScreen1 from "../assets/tornadoWebsite.webp";
import ResultsScreen2 from "../assets/pokerSolverPic.webp";
import { backgroundDiv } from "./leadSection";
interface FeedbackEngineProps {
}
const header1_1 = "Become the"
const header1_2 = "Smartest Player"
const header1_3 = "in the Room"
// pageType == "casual"
//     ? "Take your Poker Strategy to the Next Level"
//     : "Get better decisions with solver feedback on every hand"
const header2Desktop = "Solver-powered feedback on every decision, explained in plain English and tailored to your skill level."
const header2 =
    "Solver-powered feedback on every decision, explained in plain English and tailored to your skill level."

const header3 = "Our Best-in-Class Feedback Engine Makes Improving Simple and Fun"


export const FeedbackEngineDesktop: React.FC<FeedbackEngineProps> = () => {


    const [isVisible, setIsVisible] = useState(false);
    const [isVisible2, setIsVisible2] = useState(false);
    const divRef = useRef(null);
    const div2Ref = useRef(null);
    try {

        useEffect(() => {
            const observer = new IntersectionObserver(

                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            if (entry.target === divRef.current) {
                                setIsVisible(true);
                            } else if (entry.target === div2Ref.current) {
                                setIsVisible2(true);
                            }
                        } else {
                            if (entry.target === divRef.current) {
                                setIsVisible(false);
                            } else if (entry.target === div2Ref.current) {
                                setIsVisible2(false);
                            }
                        }
                    });
                },
                {
                    threshold: 0.3, // Trigger when 50% of the div is visible
                }
            );
            if (divRef.current) {
                observer.observe(divRef.current);
            }
            if (div2Ref.current) {
                observer.observe(div2Ref.current);
            }

            return () => {
                if (divRef.current) {
                    observer.unobserve(divRef.current);
                }
                if (div2Ref.current) {
                    observer.unobserve(div2Ref.current);
                }
            };
        }, []);


        const fadeInStyle = {
            opacity: isVisible ? 1 : 0,
            transition: 'opacity 1s ease-in',
        };

        const flyInStyle = {
            transform: isVisible2 ? 'translateX(0)' : 'translateX(-200%)',
            transition: 'transform 1s ease-in-out',
        };

        const flyInStyle2 = {
            transform: isVisible2 ? 'translateX(0)' : 'translateX(-300%)',
            transition: 'transform 1s ease-in-out',
        };

        const widthReference = getScreenSize().width
        const heightReference = Math.min(getScreenSize().height, widthReference) * 0.9;
        const phoneWidth = Math.min(heightReference * 0.40, getScreenSize().width * 0.2);
        const phoneHeight = phoneWidth * 2.02535;
        const isMobile = getIsMobile()
        const isTablet = getIsTablet()
        const isMobileOrTablet = isMobile || isTablet
        return (

            <div style={{
                height: "auto",
                width: "100%",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
                position: "relative",
                // Keep everything in this section inside it - an over-tall child here used to
                // spill into the section above and swallow its clicks.
                overflow: "hidden"
            }}>
                {backgroundDiv(isMobile, isTablet, isMobileOrTablet)}
                <div style={{
                    height: heightReference * 0.9,
                    minHeight: getScreenSize().width * 0.42,
                    width: "95%",
                    flexDirection: "row",
                    display: "flex",
                    justifyContent: "center", alignItems: "center",
                    position: "relative",
                }}>
                    <div
                        ref={divRef}
                        style={{
                            marginTop: "5%", marginBottom: "5%",
                            ...fadeInStyle,
                            height: "100%", width: "50%", display: "flex",
                            flexDirection: "column", justifyContent: "center",
                            alignItems: "center", position: "relative", paddingRight: getScreenSize().width > getScreenSize().height ? "6%" : "3%", paddingLeft: getScreenSize().width > getScreenSize().height ? "6%" : "3%",


                        }}>
                        <div style={{ width: "100%", marginLeft: "5%", marginRight: "5%", justifyContent: "flex-start" }}>
                            <h1 style={{
                                color: "#2a4432", textShadow: isSafari ? "1px 1px 1px rgba(255,255,255,1)" : "2px 2px 2px rgba(255,255,255,1)", width: "100%", fontFamily: "Medium",
                                fontSize: getAdjustingFontSizeByHeightWidth(heightReference * 0.08, getScreenSize().width * (0.10), header1_3.length, 88),
                                justifyContent: "center", textAlign: "center", marginBottom: "10px"
                            }}>
                                {header1_1}
                            </h1>
                            <h1 style={{
                                color: "#0f1f16", textShadow: isSafari ? "1px 1px 1px rgba(255,255,255,1)" : "2px 2px 2px rgba(255,255,255,1)", width: "100%", fontFamily: "Medium",
                                fontSize: getIsTablet() ? getAdjustingFontSizeByHeightWidth(heightReference * 0.12, getScreenSize().height < 450 ? getScreenSize().width * (0.4) : (isMobileOrTablet ? getScreenSize().width * (0.34) : getScreenSize().width * (0.5)), header1_2.length, 88) : getAdjustingFontSizeByHeightWidth(heightReference * 0.08, getScreenSize().width * (0.5), header1_2.length, 88),
                                justifyContent: "center", textAlign: "center", marginBottom: "10px"
                            }}>
                                {header1_2}
                            </h1>
                            <h1 style={{
                                color: "#2a4432", textShadow: isSafari ? "1px 1px 1px rgba(255,255,255,1)" : "2px 2px 2px rgba(255,255,255,1)", width: "100%", fontFamily: "Medium",
                                fontSize: getAdjustingFontSizeByHeightWidth(heightReference * 0.08, getScreenSize().width * (0.10), header1_3.length, 88),
                                justifyContent: "center", textAlign: "center", marginBottom: "10px"
                            }}>
                                {header1_3}
                            </h1>
                        </div>
                        <div style={{
                            marginTop: "5%",
                            height: "25.5%",
                            width: "100%",
                            justifyContent: "center",
                            alignItems: "center",
                            position: "relative",
                            display: "flex",
                            flexDirection: "column",
                            padding: "3%",
                            borderRadius: "20px",
                            background: 'linear-gradient(135deg, rgb(245, 255, 248) 0%, rgb(240, 255, 245) 25%, rgb(255, 255, 255) 50%, rgb(235, 254, 242) 75%, rgb(229, 254, 237) 100%)', // Changed angle and refined gradient
                            // Professional shadow with subtle depth
                            boxShadow: `
        0 8px 32px rgba(0, 0, 0, 0.08),
        0 4px 16px rgba(0, 0, 0, 0.04),
        0 2px 8px rgba(0, 0, 0, 0.02)
    `,
                            // Subtle border for definition
                            border: "1px solid rgba(255, 255, 255, 0.6)",
                            // Better backdrop for glass-like effect
                            backdropFilter: "blur(10px)",
                            // Smooth transitions for hover effects
                            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
                        }}>

                            <div style={{
                                height: "auto", width: getScreenSize().width > getScreenSize().height ? "90%" : "92.5%",
                                position: "relative", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "row"
                            }}>
                                <div style={{ height: "auto", width: "100%", position: "relative", display: "flex", alignItems: "left", justifyContent: "center", flexDirection: "column", marginTop: "8%", marginBottom: "8%" }}>
                                    {formatAnswer(header2Desktop, {
                                        color: "rgba(51, 41, 0, 1)", maxWidth: "100%", textShadow: "0px 0px 10px white", zIndex: 5,
                                        fontFamily: "MediumItalic", fontSize: getAdjustingFontSizeByHeightWidth(heightReference * 0.16, getScreenSize().width * (0.27), header2Desktop.length, 88),
                                        textAlign: "left", marginTop: "1%", marginBottom: "1%"
                                    })}
                                </div>
                                {isMobileOrTablet ? null : <img
                                    src={FeedbackIcon} // Reference the imported image
                                    alt="Daily Tournament Tile" // Provide an alt attribute
                                    style={{
                                        height: 150,
                                        maxWidth: "28%",
                                        objectFit: 'contain',
                                        position: "relative",
                                        filter: "sepia(100%) saturate(300%) hue-rotate(25deg) brightness(0.7) contrast(1.5)"
                                    }}
                                />}
                            </div>
                            {/* <h3 style={{ maxWidth: "80%", fontFamily: "Bold", fontSize: getAdjustingFontSizeByHeightWidth(getScreenSize().height * 0.05, getScreenSize().width * (0.90), header3.length, 88), textAlign: "center", margin: 20 }}>{header3}</h3> */}
                        </div>
                        <div style={{ justifyContent: "center", alignItems: "center", display: "flex", width: "100%", marginTop: "8%" }}>
                            {isMobileOrTablet ?
                                <div style={{ width: "65%", justifyContent: "center", alignItems: "center", display: "flex" }}>
                                    <DownloadButtonsMobile placement="feedback_engine" />
                                </div>
                                :

                                <DownloadButtonsDesktop placement="feedback_engine"
                                    height={heightReference * 0.1}
                                />
                            }
                        </div>
                    </div>
                    <div
                        ref={div2Ref}
                        style={{

                            // Sized from what actually renders (+80 for the inner column's 40px
                            // top/bottom margins). A viewport-width-based minHeight here made this
                            // box ~1000px taller than its centring row-flex parent, so it overflowed
                            // upwards and blocked the download buttons in the section above.
                            height: "100%", minHeight: phoneHeight + 80, display: "flex",
                            flexDirection: "row", justifyContent: "center",
                            alignItems: "center", width: "50%", position: "relative"
                        }}>
                        <div style={{
                            ...flyInStyle2,
                            height: "100%", display: "flex", flex: 1,
                            flexDirection: "row", justifyContent: "center",
                            alignItems: "center", position: "relative", zIndex: 2
                        }}>
                            <div
                                style={{

                                    height: "100%", width: "50%", display: "flex", marginTop: 40, marginBottom: 40,
                                    flexDirection: "column", justifyContent: "center",
                                    alignItems: "center"
                                    , transform: "translateX(-3.5%)", // Fixed transform syntax
                                }}>
                                <div style={{
                                    height: phoneHeight,
                                    width: phoneWidth,
                                }}>
                                    <FlexiblePhoneStillImage marginHorizontal={"3%"}
                                        marginTop={"1%"} image={ResultsScreen1} videoBorderRadius={70 * (getScreenSize().width * 0.2 / 400)} banner={beginnerBannerText}></FlexiblePhoneStillImage>
                                </div>
                            </div>
                        </div>
                        <div style={{

                            ...flyInStyle, display: "flex", flex: 1,
                            flexDirection: "row", justifyContent: "center",
                            alignItems: "center"
                        }}>
                            <div
                                style={{

                                    height: "100%", width: "50%", display: "flex", marginTop: 40, marginBottom: 40,
                                    flexDirection: "column", justifyContent: "center",
                                    alignItems: "center"
                                    , transform: "translateX(-3.5%)", // Fixed transform syntax
                                }}>
                                <div style={{
                                    height: phoneHeight,
                                    width: phoneWidth,
                                }}>
                                    <FlexiblePhoneStillImage marginHorizontal={"3%"}
                                        marginTop={"1%"} image={ResultsScreen2} videoBorderRadius={70 * (getScreenSize().width * 0.2 / 400)} ></FlexiblePhoneStillImage>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        )
    } catch (err) {
        console.error('FeedbackEngine:' + err)
        return (<div></div>)
    }
}

export const FeedbackEngineMobile: React.FC<FeedbackEngineProps> = () => {


    const [isVisible, setIsVisible] = useState(false);
    const [isVisible2, setIsVisible2] = useState(false);

    const divRef = useRef(null);
    const div2Ref = useRef(null);
    try {

        useEffect(() => {
            const observer = new IntersectionObserver(

                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            if (entry.target === divRef.current) {
                                setIsVisible(true);
                            } else if (entry.target === div2Ref.current) {
                                setIsVisible2(true);
                            }
                        } else {
                            if (entry.target === divRef.current) {
                                setIsVisible(false);
                            } else if (entry.target === div2Ref.current) {
                                setIsVisible2(false);
                            }
                        }
                    });
                },
                {
                    threshold: 0.1,
                }
            );
            if (divRef.current) {
                observer.observe(divRef.current);
            }
            if (div2Ref.current) {
                observer.observe(div2Ref.current);
            }

            return () => {
                if (divRef.current) {
                    observer.unobserve(divRef.current);
                }
                if (div2Ref.current) {
                    observer.unobserve(div2Ref.current);
                }
            };
        }, []);


        const fadeInStyle = {
            opacity: isVisible ? 1 : 0,
            transition: 'opacity 1s ease-in',
        };

        const flyInStyle = {
            transform: isVisible2 ? 'translateX(0)' : 'translateX(-200%)',
            transition: 'transform 1s ease-in-out',
        };

        const flyInStyle2 = {
            transform: isVisible2 ? 'translateX(0)' : 'translateX(-300%)',
            transition: 'transform 1s ease-in-out',
        };


        const isMobile = getIsMobile()
        const isTablet = getIsTablet()
        const isMobileOrTablet = isMobile || isTablet
        return (

            <div style={{
                height: "auto",
                width: "100%",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                display: "flex",
                position: "relative", overflow: "hidden",
            }}>
                <div style={{ position: "absolute", width: "100%", height: "100%" }}>
                    <img
                        src={HandHistoryGreyScale}
                        alt="Daily Tournament Tile"
                        style={{
                            width: '100%',
                            height: 'auto',
                            objectFit: 'contain',
                            position: "absolute",
                            top: "50%",
                            right: 0
                        }}
                    />
                    {backgroundDiv(isMobile, isTablet, isMobileOrTablet)}
                </div>
                <div style={{
                    height: "auto",
                    position: "relative", paddingTop: "5%",
                    width: "95%",
                    flexDirection: "column",
                    display: "flex",
                    justifyContent: "center", alignItems: "center", zIndex: 1
                }}>
                    {/* === HEADER — outside the box, matches desktop copy === */}
                    <div
                        ref={divRef}
                        style={{
                            ...fadeInStyle,
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            marginTop: 25,
                            marginBottom: 10,
                        }}>
                        <h1 style={{
                            color: "#2a4432",
                            textShadow: isSafari ? "1px 1px 1px rgba(255,255,255,1)" : "2px 2px 2px rgba(255,255,255,1)",
                            width: "100%",
                            fontFamily: "Medium",
                            fontSize: getAdjustingFontSizeByHeightWidth(getScreenSize().height * 0.03, getScreenSize().width * 0.90, header1_1.length, 88),
                            textAlign: "center",
                            marginBottom: "6px",
                        }}>
                            {header1_1}
                        </h1>
                        <h1 style={{
                            color: "#0f1f16",
                            textShadow: isSafari ? "1px 1px 1px rgba(255,255,255,1)" : "2px 2px 2px rgba(255,255,255,1)",
                            width: "100%",
                            fontFamily: "Bold",
                            fontSize: getAdjustingFontSizeByHeightWidth(getScreenSize().height * 0.09, getScreenSize().width * 0.85, header1_2.length, 88),
                            textAlign: "center",
                            marginBottom: "6px",
                        }}>
                            {header1_2}
                        </h1>
                        <h1 style={{
                            color: "#2a4432",
                            textShadow: isSafari ? "1px 1px 1px rgba(255,255,255,1)" : "2px 2px 2px rgba(255,255,255,1)",
                            width: "100%",
                            fontFamily: "Medium",
                            fontSize: getAdjustingFontSizeByHeightWidth(getScreenSize().height * 0.03, getScreenSize().width * 0.90, header1_1.length, 88),
                            textAlign: "center",
                            marginBottom: "6px",
                        }}>
                            {header1_3}
                        </h1>
                    </div>

                    {/* === CONTENT BOX — desktop copy + icon, no header or button === */}
                    <div style={{
                        width: "100%",
                        maxWidth: getScreenSize().height / 1.45,
                        justifyContent: "center",
                        alignItems: "center",
                        position: "relative",
                        display: "flex",
                        flexDirection: "column",
                        padding: "5%",
                        borderRadius: "20px",
                        background: 'linear-gradient(135deg, rgb(245, 255, 248) 0%, rgb(240, 255, 245) 25%, rgb(255, 255, 255) 50%, rgb(235, 254, 242) 75%, rgb(229, 254, 237) 100%)',
                        boxShadow: `
                            0 8px 32px rgba(0, 0, 0, 0.08),
                            0 4px 16px rgba(0, 0, 0, 0.04),
                            0 2px 8px rgba(0, 0, 0, 0.02)
                        `,
                        border: "1px solid rgba(255, 255, 255, 0.6)",
                        backdropFilter: "blur(10px)",
                        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                        marginBottom: 10,
                    }}>
                        <div style={{
                            width: "100%",
                            position: "relative",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "row",
                        }}>
                            <div style={{
                                width: "100%",
                                position: "relative",
                                display: "flex",
                                alignItems: "flex-start",
                                justifyContent: "center",
                                flexDirection: "column",

                            }}>
                                {formatAnswer(header2Desktop, {
                                    color: "rgba(51, 41, 0, 1)",
                                    maxWidth: "100%",
                                    textShadow: "0px 0px 10px white",
                                    zIndex: 5,
                                    fontFamily: "MediumItalic",
                                    fontSize: getAdjustingFontSizeByHeightWidth(getScreenSize().height * 0.12, getScreenSize().width * 0.9, header2Desktop.length, 88),
                                    textAlign: "left",
                                    marginTop: "1%",
                                    marginBottom: "1%",
                                })}
                            </div>
                            {/* <img
                                src={FeedbackIcon}
                                alt="Feedback Icon"
                                style={{
                                    height: 120,
                                    maxWidth: "28%",
                                    objectFit: 'contain',
                                    position: "relative",
                                    filter: "sepia(100%) saturate(300%) hue-rotate(25deg) brightness(0.7) contrast(1.5)",
                                    flexShrink: 0,
                                }}
                            /> */}
                        </div>
                    </div>

                    {/* === DOWNLOAD BUTTON — outside the box === */}
                    <div style={{ width: "100%", marginTop: "5%", marginBottom: "5%", justifyContent: "center", alignItems: "center", display: "flex" }}>
                        <DownloadButtonsMobile placement="feedback_engine"
                            style={{ width: getScreenSize().width * 0.4 }}
                        />
                    </div>

                    {/* === PHONE IMAGES === */}
                    <div
                        ref={div2Ref}
                        style={{
                            height: getScreenSize().height * 0.55,
                            minHeight: getScreenSize().width * 1,
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%"
                        }}>
                        <div style={{
                            ...flyInStyle2,
                            height: "100%", display: "flex", flex: 1,
                            flexDirection: "row", justifyContent: "center",
                            alignItems: "center", position: "relative", zIndex: 2
                        }}>
                            <VerticalPhoneMobile video={postFlopAll} backupPhoto={ResultsScreen1} scaleFactorInput={getScreenSize().width * 0.0045} halfMobileInput={true} banner={beginnerBannerText} />
                        </div>
                        <div style={{
                            ...flyInStyle, display: "flex", flex: 1,
                            flexDirection: "row", justifyContent: "center",
                            alignItems: "center"
                        }}>
                            <VerticalPhoneMobile video={resultsScreen} backupPhoto={ResultsScreen2} scaleFactorInput={getScreenSize().width * 0.0045} halfMobileInput={true} />
                        </div>
                    </div>
                </div>
            </div >
        )
    } catch (err) {
        console.error('FeedbackEngine:' + err)
        return (<div></div>)
    }
}